__turbopack_context__.v({
  "inverse": "QuoteSlider-module-scss-module__nu3CPG__inverse",
  "quoteSliderWrapper": "QuoteSlider-module-scss-module__nu3CPG__quoteSliderWrapper",
  "sliderWrapper": "QuoteSlider-module-scss-module__nu3CPG__sliderWrapper",
});
